<template>
	<section class="docs-container">
		<section>
			<article>
				<header>
					<code>&lt;task-item v-model="'El piso Limpio'" v-bind:is-selected="true"
						/&gt;
					</code>
				</header>
				<div style="width:275px">
					<task-item v-if="showTask" v-model="task.text" v-bind:is-selected="task.isSelected"
					  v-on:task-selected="onTaskSelected" v-on:task-delete="onTaskDelete"
					/>
				</div>
			</article>
			<article>
				<header>
					<code>&lt;tasks-list v-bind:tasks="tasks" /&gt;</code>
				</header>
				<div>
					<tasks-list v-bind:tasks="tasks" />
				</div>
			</article>
			<article>
				<header>
					<code>&lt;clock v-bind:time="'00:45'" /&gt;</code>
				</header>
				<div>
					<clock v-bind:time="time" />
				</div>
			</article>
			<article>
				<header>
					<code>
						<code>&lt;gauge v-bind:percent="{{percent}}" /&gt;</code>
					</code>
				</header>
				<div>
					<gauge v-bind:percent="percent" />
				</div>
			</article>
		</section>
	</section>
</template>

<script>

import Clock from './shared/Clock';
import TaskItem from './shared/TaskItem';
import TasksList from './shared/TasksList';
import Gauge from './shared/Gauge';

function created() {
	setInterval(() => {
		this.percent = Math.round(Math.random() * 100);
	}, 2500);
}

function data() {
	return {
		percent: 50,
		showTask: true,
		task: {
			isSelected: true,
			text: 'El piso limpio',
		},
		tasks: [
			{
				id: 1,
				isSelected: true,
				text: 'Bano Limpio',
			},
			{
				id: 2,
				isSelected: true,
				text: 'Sábanas limpias',
			},
			{
				id: 3,
				isSelected: true,
				text: 'Habitación ordenada',
			},
			{
				id: 4,
				isSelected: false,
				text: 'Refrigeradora limpio por dentro y fuera',
			},
		],
		time: '00:45',
	};
}

function onTaskDelete() {
	setTimeout(() => {
		this.showTask = false;
	}, 300);
}

function onTaskSelected() {
	this.task.isSelected = !this.task.isSelected;
}

export default {
	components: {
		Clock,
		Gauge,
		TaskItem,
		TasksList,
	},
	created,
	data,
	name: 'docs',
	methods: {
		onTaskDelete,
		onTaskSelected,
	},
};
</script>

<style lang="scss" scoped>
.docs-container {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// Docs.vue?e3aed6f2